const initialState = {
    isAuthenticated: false,
    user: null,
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_SUCCESS":
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload,
            };
        case 'UPDATE_USER_DETAILS':
            return {
                ...state,
                isAuthenticated:true,
                user: action.payload,
            };
        case "LOGOUT":
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            };
        default:
            return state;
    }
};

export default loginReducer;